import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required,
    string,
    email,
    boolean
} from 'vue-mc/validation';

export class Category extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            name: '',
            type: 1,
            keywords: '',
            sort_order: 0,
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            name: String,
            type: Number,
            keywords: String,
            sort_order: Number,
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            name: string.and(required),
            type: integer,
            keywords: string,
            sort_order: integer,
        };
    }

    public routes() {
        return {
            fetch: "categories/{id}",
            save: "categories",
            delete: "categories/{id}"
        };
    }

    private categoryTypes = [
        { id: CategoryType.Food, name: "Food" },
        { id: CategoryType.Drinks, name: "Drinks" }
    ];

    public getCategoryTypeName() {
        const categoryType = this.categoryTypes.find(x => x.id === this.type);
        return categoryType ? categoryType.name : "";
    }
}

export class CategoryCollection extends Collection {
    public model() {
        return Category;
    }

    public defaults() {
        return {
            orderBy: 'name',
        };
    }

    public routes() {
        return {
            fetch: "categories",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}

export enum CategoryType {
    Food = 1,
    Drinks = 2
}